export class FontConfig {
    id;
    familyNames = null;
    requiredFontFaces = null;
    constructor(id, familyNames, requiredFontFaces) {
        this.id = id;
        this.familyNames = familyNames || null;
        this.requiredFontFaces = requiredFontFaces || null;
    }
}
export class Theme {
    id;
    headlineFontConfig = null;
    bodyFontConfig = null;
    constructor(id, headlineFontConfig, bodyFontConfig) {
        this.id = id;
        this.headlineFontConfig = headlineFontConfig || null;
        this.bodyFontConfig = bodyFontConfig || null;
    }
    static all() {
        let themes = [];
        for (let themeId in themeConfig) {
            let theme = this.getById(themeId);
            if (theme) {
                themes.push(theme);
            }
        }
        return themes;
    }
    static getById(id) {
        if (!id) {
            console.error('@Theme#getById: No Id given ', id);
            return null;
        }
        if (!themeConfig[id]) {
            console.error('@Theme#getById: Theme not found ', id);
            return null;
        }
        let themeData = themeConfig[id];
        if (themeData.headlineFont && !fontConfig[themeData.headlineFont]) {
            console.error('@Theme#getById: headLineFont not found ', themeData.headlineFont, id);
            return null;
        }
        if (themeData.bodyFont && !fontConfig[themeData.bodyFont]) {
            console.error('@Theme#getById: bodyFont not found ', themeData.bodyFont, id);
            return null;
        }
        let theme = new Theme(id, fontConfig[themeData.headlineFont] ? new FontConfig(themeData.headlineFont, fontConfig[themeData.headlineFont].familyNames, fontConfig[themeData.headlineFont].requiredFontFaces) : null, fontConfig[themeData.bodyFont] ? new FontConfig(themeData.bodyFont, fontConfig[themeData.bodyFont].familyNames, fontConfig[themeData.bodyFont].requiredFontFaces) : null);
        return theme;
    }
}
const fontConfig = {
    "montserrat": {
        familyNames: "Montserrat, sans-serif",
        requiredFontFaces: `
            @font-face {
                font-family: Montserrat;
                src: url('./fonts/Montserrat-VF/Montserrat-VF.woff2') format('woff2-variations');
                font-style: normal;
            }
            @font-face {
                font-family: Montserrat;
                src: url('./fonts/Montserrat-VF/Montserrat-Italic-VF.woff2') format('woff2-variations');
                font-style: italic;
                /*    ^ only has weight axis (200-900 range) */
            }
        `
    },
    "playfair-display": {
        familyNames: '"Playfair Display", serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Playfair Display";
                font-weight: 400 800;
                src: url('./fonts/Playfair_Display/PlayfairDisplay-VariableFont_wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Playfair Display";
                font-weight: 400 800;
                src: url('./fonts/Playfair_Display/PlayfairDisplay-Italic-VariableFont_wght.ttf');                    
                font-style: italic;                
            }
        `
    },
    "open-sans": {
        familyNames: '"Open Sans", sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Open Sans";
                font-weight: 400 800;
                src: url('./fonts/Open_Sans/OpenSans-VariableFont_wdth,wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Open Sans";
                font-weight: 400 800;
                src: url('./fonts/Open_Sans/OpenSans-Italic-VariableFont_wdth,wght.ttf');                    
                font-style: italic;                
            }
        `
    },
    "inter": {
        familyNames: 'Inter, sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Inter";
                font-weight: 400 800;
                src: url('./fonts/Inter/Inter-VariableFont_opsz,wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Inter";
                font-weight: 400 800;
                src: url('./fonts/Inter/Inter-Italic-VariableFont_opsz,wght.ttf');                    
                font-style: italic;                
            }
        `
    },
    "source-sans-3": {
        familyNames: '"Source Sans 3", sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Source Sans 3";
                font-weight: 400 800;
                src: url('./fonts/Source_Sans_3/SourceSans3-VariableFont_wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Source Sans 3";
                font-weight: 400 800;
                src: url('./fonts/Source_Sans_3/SourceSans3-Italic-VariableFont_wght.ttf');                    
                font-style: italic;                
            }
        `
    },
    "libre-baskerville": {
        familyNames: '"Libre Baskerville", serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Libre Baskerville";
                font-weight: 400 800;
                src: url('./fonts/Libre_Baskerville/LibreBaskerville-VariableFont_wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Libre Baskerville";
                font-weight: 400 800;
                src: url('./fonts/Libre_Baskerville/LibreBaskerville-Italic-VariableFont_wght.ttf');                    
                font-style: italic;                
            }
        `
    },
    "lora": {
        familyNames: 'Lora, sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Lora";
                font-weight: 400 800;
                src: url('./fonts/Lora/Lora-VariableFont_wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Lora";
                font-weight: 400 800;
                src: url('./fonts/Lora/Lora-Italic-VariableFont_wght.ttf');
                font-style: italic;                
            }
        `
    },
    "dm-sans": {
        familyNames: 'Lora, sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Lora";
                font-weight: 400 800;
                src: url('./fonts/DM_Sans/DMSans-VariableFont_opsz,wght.ttf');
                font-style: normal;
            }
            @font-face {
                font-family: "Lora";
                font-weight: 400 800;
                src: url('./fonts/DM_Sans/DMSans-Italic-VariableFont_opsz,wght.ttf');
                font-style: italic;                
            }
        `
    },
    "space-grotesk": {
        familyNames: '"Space Grotesk", sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Space Grotesk";
                font-weight: 400 800;
                src: url('./fonts/Space_Grotesk/SpaceGrotesk-VariableFont_wght.ttf');
                font-style: normal;
            }            
        `
    },
    "philosopher": {
        familyNames: 'Philosopher, serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Philosopher";
                font-weight: 400
                src: url('./fonts/Philosopher/Philosopher-Regular.ttf');
                font-style: normal;
            }            
            @font-face {
                font-family: "Philosopher";
                font-weight: 700
                src: url('./fonts/Philosopher/Philosopher-Bold.ttf');
                font-style: normal;
            }            
            @font-face {
                font-family: "Philosopher";
                font-weight: 400
                font-style: italic;
                src: url('./fonts/Philosopher/Philosopher-Italic.ttf');
            }            
            @font-face {
                font-family: "Philosopher";
                font-weight: 700
                src: url('./fonts/Philosopher/Philosopher-BoldItalic.ttf');
                font-style: italic;
            
            }            
        `
    },
    "dm-serif-display": {
        familyNames: 'Philosopher, sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Philosopher";
                font-weight: 400
                src: url('./fonts/DM_Serif_Display/DMSerifDisplay-Regular.ttf');
                font-style: normal;
            }            
            @font-face {
                font-family: "Philosopher";
                font-weight: 400
                src: url('./fonts/DM_Serif_Display/DMSerifDisplay-Italic.ttf');
                font-style: italic;
            }
        `
    },
    "oswald": {
        familyNames: '"Oswald", sans-serif',
        requiredFontFaces: `
            @font-face {
                font-family: "Oswald";
                font-weight: 400 800;
                src: url('./fonts/Oswald/Oswald-VariableFont_wght.ttf');
                font-style: normal;
            }            
        `
    },
    "poppins": {
        familyNames: '"Poppins", sans-serif',
        requiredFontFaces: `
            /* Poppins - Thin 100 */
            @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 100;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Thin.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 100;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-ThinItalic.woff2") format("woff2");
                }

                /* Poppins - ExtraLight 200 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 200;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-ExtraLight.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 200;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-ExtraLightItalic.woff2") format("woff2");
                }

                /* Poppins - Light 300 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 300;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Light.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 300;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-LightItalic.woff2") format("woff2");
                }

                /* Poppins - Regular 400 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 400;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Regular.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 400;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Italic.woff2") format("woff2");
                }

                /* Poppins - Medium 500 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 500;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Medium.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 500;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-MediumItalic.woff2") format("woff2");
                }

                /* Poppins - SemiBold 600 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 600;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-SemiBold.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 600;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-SemiBoldItalic.woff2") format("woff2");
                }

                /* Poppins - Bold 700 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 700;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Bold.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 700;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-BoldItalic.woff2") format("woff2");
                }

                /* Poppins - ExtraBold 800 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 800;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-ExtraBold.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 800;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-ExtraBoldItalic.woff2") format("woff2");
                }

                /* Poppins - Black 900 */
                @font-face {
                font-family: "Poppins";
                font-style: normal;
                font-weight: 900;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-Black.woff2") format("woff2");
                }

                @font-face {
                font-family: "Poppins";
                font-style: italic;
                font-weight: 900;
                font-display: swap;
                src: url("./fonts/Poppins/Poppins-BlackItalic.woff2") format("woff2");
                }
        `
    },
};
// OIDO (Montserrat / Montserrat)
// Refined (Playfair Display / Open Sans)
// Grotesk (Space Grotesk / Inter)
// Impact (Oswald / Source Sans 3)
// Humanist (Philosopher / Poppins)
// Harmony (Poppins / Lora)
// Elegant (DM Serif / DM Sans)
// Editorial (Libre Baskerville / Source Sans 3)
const themeConfig = {
    'oido': {
        headlineFont: "montserrat",
        bodyFont: "montserrat"
    },
    'refined': {
        headlineFont: "playfair-display",
        bodyFont: "open-sans"
    },
    'grotesk': {
        headlineFont: "space-grotesk",
        bodyFont: "inter"
    },
    'impact': {
        headlineFont: "oswald",
        bodyFont: "source-sans-3"
    },
    'humanist': {
        headlineFont: "philosopher",
        bodyFont: "poppins"
    },
    'harmony': {
        headlineFont: "poppins",
        bodyFont: "lora"
    },
    'elegant': {
        headlineFont: "dm-serif",
        bodyFont: "dm-sans"
    },
    'editorial': {
        headlineFont: "libre-baskerville",
        bodyFont: "source-sans-3"
    },
};
